import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    pageTitle: "",
    newChatMessage: "",
    unreadMessageCount: 0,
    updateChatMessage: "",
    removedChatGroup: null as any,
    // Thời điểm socket NỐI LẠI sau khi đứt. Đổi giá trị = tín hiệu cho Chat.tsx kéo lại dữ liệu
    // đã lỡ trong lúc mất kết nối (bộ đếm chưa đọc, danh sách nhóm, tin nhắn nhóm đang mở).
    socketReconnectedAt: 0,
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
      document.title = action.payload;
    },
    setNewChatMessage: (state, action) => {
      state.newChatMessage = action.payload;
    },
    setUnreadMessageCount: (state, action) => {
      state.unreadMessageCount = action.payload;
    },
    setUpdateChatMessage: (state, action) => {
      state.updateChatMessage = action.payload;
    },
    // Lưu payload event CHAT_GROUP_REMOVED để component chat xử lý (xóa nhóm khỏi danh sách...).
    // Gán object mới mỗi lần để effect luôn chạy lại (idempotent ở phía xử lý).
    setRemovedChatGroup: (state, action) => {
      state.removedChatGroup = action.payload;
    },
    setSocketReconnected: (state, action) => {
      state.socketReconnectedAt = action.payload;
    },
    // Đặt lại bộ đếm chưa đọc của MỘT nhóm khi nhận event `unread-updated` — chính người dùng
    // này vừa đọc nhóm đó ở app nhân viên (web và app dùng chung một bộ đếm ở server).
    //
    // unreadMessageCount là map nhiều "xô" lồng nhau: chat_type, chat_type_sub_chat_type,
    // chat_type_sub_chat_type_owner_status, chat_type_owner_status — mỗi xô là {groupId: count}.
    // Event chỉ mang group_id nên duyệt mọi xô đang chứa nhóm này, thay vì phải biết trước nhóm
    // thuộc xô nào như markAsRead() ở Chat.tsx làm.
    setGroupUnreadCount: (state, action) => {
      const { groupId, unread } = action.payload || {};
      if (groupId === undefined || groupId === null) return;
      const buckets: any = state.unreadMessageCount;
      // Giá trị khởi tạo là số 0 cho tới khi /unread-by-group trả về; Object.keys(0) là [].
      Object.keys(buckets || {}).forEach((bucketKey: string) => {
        const bucket = buckets[bucketKey];
        if (bucket && bucket[groupId] !== undefined) {
          bucket[groupId] = unread;
        }
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPageTitle,
  setNewChatMessage,
  setUnreadMessageCount,
  setUpdateChatMessage,
  setRemovedChatGroup,
  setSocketReconnected,
  setGroupUnreadCount,
} = appSlice.actions;

export default appSlice.reducer;
